import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaxLengthModule } from '@avenir-client-web/max-length';
import { TextareaModule } from 'primeng/textarea';
import { TextAreaComponent } from './text-area.component';

@NgModule({
  imports: [
    CommonModule,
    TextareaModule,
    MaxLengthModule,
    FormsModule,
    TextAreaComponent,
  ],
  exports: [TextAreaComponent],
})
export class TextAreaModule {}
